export var BASE_FONT_SIZE = 16;
export var MENU_PADDING_LEFT = 16;